import React, { createElement } from 'react';
import styles from './index.css';

interface MaskProps {
    visible: boolean
    zIndex: number
    children?: any
    contentStyle?: object
}

export const Mask = (props: MaskProps) => {
    const { visible, children, zIndex, contentStyle } = props;

    if (visible) {
        return (
            <div className={styles.mask} style={{ zIndex }}>
                <div className={styles.maskContent} style={contentStyle}>{children}</div>
            </div>
        );
    } else {
        return null;
    }
};
